import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('classes-toxicologicas/',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('classes-toxicologicas',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('classes-toxicologicas/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('classes-toxicologicas/'+item.id_classe_toxicologica,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}